import { render } from "./PDFContextViewer.vue?vue&type=template&id=f345b312&scoped=true"
import script from "./PDFContextViewer.vue?vue&type=script&lang=js"
export * from "./PDFContextViewer.vue?vue&type=script&lang=js"

import "./PDFContextViewer.vue?vue&type=style&index=0&id=f345b312&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f345b312"]])

export default __exports__